import {
    Accordion,
    Breakpoints,
    Container,
    DisplayTag,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import {globalColors, SizeEnum} from '@volkswagen-onehub/tokens'
import styled from 'styled-components'
import {Global} from '../../shared/variables'
import React, {useState} from 'react'
import {SimulationButtons} from './SimulationButtons'
import {SingleSimulation} from '../../types/SingleSimulation'
import {SimulationData} from './SimulationData'
import {SimulationLinks} from './SimulationLinks'

const SimulationAccordionContainer = styled.li`
    * {
        word-break: normal;
    }
`

const ButtonsFlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.size.static150};
    padding-top: ${(props) => props.theme.size.static150};
    padding-bottom: ${(props) => props.theme.size.static150};

    @media (min-width: ${Breakpoints.b1280}px) {
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: nowrap;
    }
`

const ButtonsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: ${(props) => props.theme.size.static150};
    padding-top: ${(props) => props.theme.size.static150};
    padding-bottom: ${(props) => props.theme.size.static150};
`

const SimulationTag = styled(DisplayTag)<{$highlighted: boolean}>`
    background-color: ${({theme, $highlighted}) =>
        $highlighted
            ? theme.colors.signal.progress
            : globalColors.ultramarine['80']};
    color: ${({theme}) => theme.colors.content.inverted};
    white-space: normal;
    height: fit-content;

    & > div,
    p {
        margin: 0;
        font-weight: bold;
    }
`

interface SimulationProps {
    index: number
    modelName: string
    promoData: SingleSimulation
    infoUrl: string
    infoUrlPassThrough: boolean
    image: string
    singleModel: boolean
}

export function SimulationAccordion(props: SimulationProps): React.JSX.Element {
    const [isOpen, setIsOpen] = useState(props.index === Global.ZERO)
    const accordionLabel = `${
        isOpen ? 'Nascondi' : 'Mostra'
    } dettagli offerta ${props.modelName} ${props.promoData.version}`

    return (
        <SimulationAccordionContainer>
            <Accordion
                key={props.index}
                id={String(props.promoData.id)}
                aria-label={accordionLabel}
                headline={
                    <Container
                        horizontalAlign="flex-start"
                        wrap="always"
                        gutter={SizeEnum.static150}
                    >
                        <SimulationData
                            promoData={props.promoData}
                            modelName={props.modelName}
                            color={TokenTextColor.primary}
                        />

                        {props.promoData.eyeCatcherText && (
                            <SimulationTag
                                appearance="technical"
                                text={props.promoData.eyeCatcherText}
                                $highlighted={props.promoData.is_highlighted}
                            />
                        )}
                    </Container>
                }
                onClick={() => {
                    setIsOpen(!isOpen)
                }}
                isOpen={isOpen}
            >
                {props.promoData.legal_notes && (
                    <SimulationLinks
                        index={props.index}
                        promoData={props.promoData}
                        legalNotes={props.promoData.legal_notes}
                        configurationCode={props.promoData.configurationCode}
                        simulationId={props.promoData.id}
                    />
                )}

                {!props.singleModel ? (
                    <ButtonsContainer>
                        <SimulationButtons
                            promoData={props.promoData}
                            image={props.image}
                            modelName={props.modelName}
                            infoCtaUrl={props.infoUrl}
                            infoCtaUrlParamsPassThrough={
                                props.infoUrlPassThrough
                            }
                            promoIndex={props.index}
                        />
                    </ButtonsContainer>
                ) : (
                    <ButtonsFlexContainer>
                        <SimulationButtons
                            promoData={props.promoData}
                            image={props.image}
                            modelName={props.modelName}
                            infoCtaUrl={props.infoUrl}
                            infoCtaUrlParamsPassThrough={
                                props.infoUrlPassThrough
                            }
                            promoIndex={props.index}
                        />
                    </ButtonsFlexContainer>
                )}
            </Accordion>
        </SimulationAccordionContainer>
    )
}
